<template>
    <div class="fixed bottom-4 right-4 z-40">
        <div v-show="showCard" class="absolute -right-2 bottom-20">
            <div
                class="tooltip-b-r flex w-60 items-start rounded-md bg-whatsapp p-2 text-left shadow-2xl md:w-80"
            >
                <span class="mr-2 text-lg text-white lg:text-xl">
                    {{ message }}
                </span>
                <button
                    type="button"
                    aria-label="Cerrar notificación"
                    class="flex-shrink-0 rounded-full bg-white p-1 text-theme-danger transition hover:opacity-80"
                    @click="closeCard"
                >
                    <x-mark-icon class="h-4 w-4" />
                </button>
            </div>
        </div>
        <div class="relative">
            <a
                :href="href"
                target="_blank"
                rel="noopener"
                aria-label="Escríbenos por WhatsApp"
                class="flex h-16 w-16 items-center justify-center rounded-full bg-whatsapp p-3 text-white shadow-lg"
                @click="onOpen"
            >
                <whatsapp-icon class="h-full w-full" />
            </a>
            <div
                v-show="showBadge"
                class="absolute top-0 right-0 -mt-2 -mr-2 flex h-7 w-7"
            >
                <span
                    v-show="showPulse"
                    class="absolute inline-flex h-full w-full animate-ping rounded-full bg-theme-danger opacity-75"
                ></span>
                <button
                    type="button"
                    aria-label="Ver mensaje"
                    class="relative flex h-6 w-6 items-center justify-center rounded-full bg-theme-danger text-sm text-white"
                    @click="toggleCard"
                >
                    1
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import WhatsappIcon from "@/components/icons/WhatsappIcon.vue";
import XMarkIcon from "@/components/icons/XMarkIcon.vue";

// Mismo comportamiento que WhatsAppCard de ecommerce: primero el botón,
// luego el "1" con pulso y al rato se abre el mensaje.
const BADGE_DELAY_MS = 4000;
const CARD_DELAY_MS = 2500;

export default {
    name: "SupportWhatsappBubble",

    components: { WhatsappIcon, XMarkIcon },

    props: {
        message: {
            type: String,
            default: ""
        },
        href: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            showBadge: false,
            showPulse: false,
            showCard: false,
            timers: []
        };
    },

    mounted() {
        this.timers.push(
            setTimeout(() => {
                this.showBadge = true;
                this.showPulse = true;
                this.timers.push(
                    setTimeout(() => {
                        this.showCard = true;
                        this.showPulse = false;
                    }, CARD_DELAY_MS)
                );
            }, BADGE_DELAY_MS)
        );
    },

    beforeDestroy() {
        this.timers.forEach(clearTimeout);
    },

    methods: {
        toggleCard() {
            this.showCard = !this.showCard;
            this.showPulse = false;
        },
        closeCard() {
            this.showCard = false;
            this.showPulse = false;
        },
        onOpen() {
            this.showBadge = false;
            this.showCard = false;
            this.$emit("open");
        }
    }
};
</script>
